import React from 'react';
import { Wrench, Clock } from 'lucide-react';
import { useWebSettings } from '../../Context/WebSettings/WebSettingsContext';
import { StatusPage } from '../../Components/StatusPage/StatusPage';
import { formatMaintenanceTime } from '../../Utils/date';
import styles from '../../Components/StatusPage/Style.module.css';

export const Maintenance = () => {
  const { maintenanceMessage, maintenanceEndTime } = useWebSettings();
  const expectedReturn = formatMaintenanceTime(maintenanceEndTime);
  return (
    <StatusPage
      icon={<Wrench size={56} strokeWidth={1.5} />}
      heading="We're making things better."
      description={maintenanceMessage || "Natureland's online booking is temporarily offline for scheduled maintenance. We'll be back shortly."}
      // badge={(
      //   <>
      //     <span className={styles.badgeLabel}>
      //       <Clock size={16} strokeWidth={2} />
      //       {expectedReturn ? 'Expected back online:' : "We'll be back online shortly"}
      //     </span>
      //     {expectedReturn && <time dateTime={maintenanceEndTime}>{expectedReturn}</time>}
      //   </>
      // )}
      // badge={expectedReturn ? 'Expected back online:' : "We'll be back online shortly"}
      isBadge={true}
      // badge={expectedReturn ? 'Expected back online:' : "We'll be back online shortly"}
      badgeTime={expectedReturn && <time dateTime={maintenanceEndTime}>{expectedReturn}</time>}
      secondaryLabel="Refresh Page"
      onSecondaryClick={() => window.location.reload()}
      footer={<>Need help? <a href="https://www.natureland.com.sg/locations/" target="_blank" rel="noopener noreferrer">Contact our front desk</a></>}
    />
  );
};

export default Maintenance;
